// MOMKIS - Mapping couleur partagé (nom de valeur d'option -> couleur CSS).
// Utilisé en repli UNIQUEMENT quand un produit n'a pas de swatch Shopify
// natif configuré (value.swatch.color) : sur la fiche produit
// (assets/momkis-pdp-sync.js, assets/momkis-pdp-offer.js) ET dans le panier
// (assets/momkis-cart-drawer.js), d'où l'extraction dans un fichier séparé
// chargé indépendamment sur toutes les pages (le panier peut s'ouvrir
// n'importe où, pas seulement sur une fiche produit).
window.MOMKIS_COLOR_MAP = window.MOMKIS_COLOR_MAP || {
  ivoire: '#DCC6B6',
  ivory: '#DCC6B6',
  beige: '#DCC6B6',
  abricot: '#E3B48A',
  apricot: '#E3B48A',
  cannelle: '#C68A5B',
  cinnamon: '#C68A5B',
  terracotta: '#C97D5D',
  'rose poussiéreux': '#D9A7A9',
  'rose poudré': '#D9A7A9',
  'dusty pink': '#D9A7A9',
  rose: '#E0BEC4',
  pink: '#E0BEC4',
  sauge: '#B7C5AE',
  sage: '#B7C5AE',
  vert: '#B7C5AE',
  green: '#B7C5AE',
  blanc: '#FFFFFF',
  white: '#FFFFFF',
  noir: '#332F2C',
  black: '#332F2C',
  gris: '#B7B2AC',
  grey: '#B7B2AC',
  gray: '#B7B2AC',
  bleu: '#A9C1D1',
  blue: '#A9C1D1',
  taupe: '#B9A99A',
  nude: '#F3E6DD',
};
